export const CUSTOM_AMOUNT = 'customAmount'
export const AMOUNT_PRESET = 'amountPreset'
export const PURCHASE_METHOD = 'purchaseMethod'
export const PURCHASE_METHOD_MINT_ADDRESS = 'purchaseMethodMintAddress'
export const PURCHASE_VENDOR = 'purchaseVendor'
export const GUEST_CHECKOUT = 'guestCheckout'
export const GUEST_EMAIL = 'guestEmail'
export const PAGE = 'page'

// Pay between $1 and $100 extra
export const minimumPayExtraAmountCents = 100
export const maximumPayExtraAmountCents = 10000

export const CENTS_TO_USDC_MULTIPLIER = 10000
export const DEFAULT_PURCHASE_AMOUNT_CENTS = 10 * 100
